import createDataGridModel from '../../../util/createDataGridModel';
import { MyRolesTab } from './type.ts';

export const createMyRolesTable = ({ getManageableRolesFx } : MyRolesTab) => {
  const $$rolesDataGrid = createDataGridModel({ type: 'client', effect: getManageableRolesFx });

  return {
    $$rolesDataGrid
  };
};